/* motor vanilla do swiper-element do concorrente (div.ce-swiper-container[data-cl-sw]); mesma conta do Swiper:
   slide = (largura - (spv-1)*gap) / spv; breakpoints pela largura da janela; translate limitado ao fim (sem loop). */
(function(){
  function conf(el){
    var c; try { c = JSON.parse(el.getAttribute('data-cl-sw') || '{}'); } catch(e){ c = {}; }
    var r = {spv: c.spv || 1, gap: c.gap || 0, enabled: c.enabled !== false};
    if (c.bp) {
      var w = window.innerWidth;
      Object.keys(c.bp).map(Number).sort(function(a, b){ return a - b; }).forEach(function(k){
        if (w >= k) { var b = c.bp[k]; if (b.slidesPerView != null) r.spv = b.slidesPerView; if (b.spaceBetween != null) r.gap = b.spaceBetween; if (b.enabled != null) r.enabled = b.enabled; }
      });
    }
    r.loop = !!c.loop; r.autoplay = c.autoplay || 0; r.speed = c.speed || 300; r.pagination = !!c.pagination;
    r.nextEl = c.nextEl; r.prevEl = c.prevEl;
    return r;
  }
  function slides(st){ return Array.prototype.slice.call(st.track.children); }
  function go(st, i, anim){
    var c = st.c; if (!c || !st.n) return;
    if (c.loop) i = ((i % st.n) + st.n) % st.n; else i = Math.max(0, Math.min(st.pages - 1, i));
    st.i = i;
    var x = st.auto ? Math.min(slides(st)[i].offsetLeft, st.max) : c.loop ? i * (st.size + c.gap) : Math.min(i * (st.size + c.gap), st.max);
    st.track.style.transition = anim ? 'transform ' + c.speed + 'ms ease' : 'none';
    st.track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
    if (st.dots) Array.prototype.forEach.call(st.dots.children, function(d, k){ d.classList.toggle('is-active', k === i); });
    if (!c.loop) {
      if (st.prev) st.prev.classList.toggle('swiper-button-disabled', i === 0);
      if (st.next) st.next.classList.toggle('swiper-button-disabled', i >= st.pages - 1);
    }
    if (st.swBtns) {
      var lock = st.max <= 0;
      [st.prev, st.next].forEach(function(b, k){
        if (!b) return;
        b.classList.toggle('swiper-button-lock', lock);
        b.classList.toggle('invisible', lock || (k === 0 ? i === 0 : i >= st.pages - 1));
      });
    }
    slides(st).forEach(function(s, k){ s.classList.toggle('swiper-slide-active', k === i); });
  }
  function layout(st){
    var c = st.c = conf(st.el), W = st.el.clientWidth, ss = slides(st), n = ss.length;
    if (!W || !n) return;
    if (c.spv === 'auto') {
      // slides-per-view="auto": largura natural de cada slide (margem inline do Swiper preservada)
      st.auto = true; st.n = n;
      ss.forEach(function(s, k){ s.style.flexShrink = '0'; if (c.gap && !s.style.marginRight) s.style.marginRight = (k < n - 1 ? c.gap : 0) + 'px'; });
      st.max = Math.max(0, st.track.scrollWidth - W);
      st.pages = 1; while (st.pages < n && ss[st.pages - 1].offsetLeft < st.max) st.pages++;
      go(st, st.i, false);
      return;
    }
    var spv = c.spv === 'auto' ? 1 : c.spv, size = (W - (spv - 1) * c.gap) / spv;
    ss.forEach(function(s, k){ s.style.flexShrink = '0'; s.style.width = size + 'px'; s.style.marginRight = ((k < n - 1 || c.loop) ? c.gap : 0) + 'px'; });
    st.size = size; st.n = n;
    st.max = Math.max(0, n * size + (n - 1) * c.gap - W);
    st.pages = c.loop ? n : Math.max(1, Math.ceil(n - spv + 1 - 1e-6));
    if (st.dots) {
      st.dots.style.display = st.pages > 1 ? '' : 'none';
      if (st.dots.children.length !== st.pages) {
        st.dots.innerHTML = '';
        for (var k = 0; k < st.pages; k++) { (function(k){ var b = document.createElement('span'); b.className = 'cl-sw-dot'; b.addEventListener('click', function(){ go(st, k, true); }); st.dots.appendChild(b); })(k); }
      }
    }
    go(st, st.i, false);
  }
  function setup(el){
    if (el.__clSw) return el.__clSw;
    var track = document.createElement('div'); track.className = 'cl-sw-track';
    Array.prototype.slice.call(el.children).forEach(function(ch){ if (ch.classList.contains('ce-swiper-slide')) track.appendChild(ch); });
    el.insertBefore(track, el.firstChild);
    var st = {el: el, track: track, i: 0};
    el.__clSw = st;
    el.clSwGo = function(i){ go(st, i, true); };
    var root = el.closest('.cl-shopify-section') || el.parentElement;
    var c0 = conf(el);
    function btn(sel, fb){ var b = null; try { b = sel && root.querySelector(sel); } catch(e){} return b || root.querySelector(fb); }
    // amostras de cor dos cards: setas proprias logo depois do container (product-swatches.js dele)
    var sb = el.nextElementSibling && el.nextElementSibling.classList.contains('swatch_slider_btns') ? el.nextElementSibling : null;
    if (sb) {
      st.swBtns = true;
      st.next = sb.querySelector('.btn-slide-next--color-swatch-slider');
      st.prev = sb.querySelector('.btn-slide-prev--color-swatch-slider');
    } else {
      st.next = btn(c0.nextEl, '.swiper-button-next, .btn-slide-next');
      st.prev = btn(c0.prevEl, '.swiper-button-prev, .btn-slide-prev');
    }
    if (st.next) st.next.addEventListener('click', function(e){ e.preventDefault(); go(st, st.i + 1, true); });
    if (st.prev) st.prev.addEventListener('click', function(e){ e.preventDefault(); go(st, st.i - 1, true); });
    if (c0.pagination) { var p = document.createElement('div'); p.className = 'cl-sw-dots'; el.appendChild(p); st.dots = p; }
    // arrasto (mouse e toque): o trilho acompanha o dedo; solta -> proximo/anterior. touch-action:pan-y no CSS deixa a
    // rolagem vertical com o navegador e entrega o gesto horizontal aqui. Vale mesmo com enabled:false do dele quando
    // ha mais de uma pagina (no mobile os cards ficam com 1.5 por tela e o visitante precisa arrastar).
    var x0 = null, y0 = 0, base = 0, drag = false;
    function canDrag(){ return st.c && (st.c.enabled || st.pages > 1) && st.n > 1 && !(st.max <= 0 && !st.c.loop); }
    function curX(){ var m = /translate3d\((-?[\d.]+)px/.exec(st.track.style.transform || ''); return m ? parseFloat(m[1]) : 0; }
    // noSwiping do Swiper: toque que comeca dentro de .swiper-no-swiping (ou da classe do atributo no-swiping-class)
    // nao arrasta ESTE carrossel (amostras de cor dentro dos cards, antes/depois); o mais interno que aceitar fica com o gesto
    var noSw = el.getAttribute('no-swiping-class') || 'swiper-no-swiping';
    el.addEventListener('pointerdown', function(e){
      if (e.button > 0 || e.__clSwTaken || !canDrag()) return;
      var ns = e.target.closest && (e.target.closest('.' + noSw) || e.target.closest('.before-effect-main-div'));
      if (ns && el.contains(ns)) return;
      e.__clSwTaken = true;
      x0 = e.clientX; y0 = e.clientY; base = curX(); drag = false; st.moved = false;
    });
    el.addEventListener('pointermove', function(e){
      if (x0 == null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!drag) {
        if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) { if (Math.abs(dy) > 10) x0 = null; return; }
        drag = true; try { el.setPointerCapture(e.pointerId); } catch(_) {}
      }
      e.preventDefault();
      st.track.style.transition = 'none';
      st.track.style.transform = 'translate3d(' + (base + dx) + 'px,0,0)';
    });
    function end(e){
      if (x0 == null) return; var dx = (e && e.clientX != null ? e.clientX : x0) - x0; x0 = null;
      if (!drag) return; drag = false;
      if (Math.abs(dx) > 30) { st.moved = true; go(st, st.i + (dx < 0 ? 1 : -1), true); } else go(st, st.i, true);
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', function(){ if (drag) { drag = false; go(st, st.i, true); } x0 = null; });
    el.addEventListener('dragstart', function(e){ if (x0 != null) e.preventDefault(); });
    el.addEventListener('click', function(e){ if (st.moved) { e.preventDefault(); e.stopPropagation(); st.moved = false; } }, true);
    if (c0.autoplay) setInterval(function(){ if (!document.hidden && st.c && st.c.enabled) go(st, st.i + 1, true); }, c0.autoplay);
    return st;
  }
  function boot(){
    document.querySelectorAll('.ce-swiper-container[data-cl-sw]').forEach(function(el){ layout(setup(el)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(boot, 60); });
  document.addEventListener('shopify:section:load', boot);
  window.clSwBoot = boot;
})();
